import * as React from "react";
import { useMemo } from "react";
import { useInputTitleResolver } from "views/hooks/useInputAndNodeTitles";
const InputField = ({ value }) => {
  var _a;
  const resolveTitle = useInputTitleResolver(useMemo(() => [value], [value]));
  return /* @__PURE__ */ React.createElement("span", { title: value }, (_a = resolveTitle(value)) != null ? _a : value);
};
export default InputField;
